import Logo from "./Logo"
import BaseSelectionsArea from "./BaseSelectionsArea";

function Head({ selectedState, onSelect }) {
  return (
    <div className="grid grid-cols-5">
      <Logo />
      <BaseSelectionsArea
        selectedState={selectedState}
        onSelect={onSelect}
      />
    </div>
  );
}

export default Head;
